export const JsonExample = {
  codiceHotel: '', // codice hotel, ad ora non serve
  ragioneHotel: 'Hotel Mario', // nome dell'hotel
  paxVou: 'Luigi Verdi', // nome del passaggero
  dataInVouEng: '12-Dec-2024', // data di check-in
  dataOutVouEng: '13-Dec-2024', // data di check-out
  riferimentoVou: '1234567890', // numero di conferma di prenotazione
  flagCamera: 'Y', // flag per la camera
  flagCityTax: 'Y', // flag per la tassa di soggiorno
  flagColazione: 'N', // flag per la colazione
  flagCena: 'N', // flag per la cena
  flagFullCredit: 'N', // flag per il full credit
  desOthers: 'Camera + city tax', // descrizione di tutti i servizi
  tipoCdc: 'V', // tipo carta J => JCB, M => Mastercard, V => Visa, D => Diners, A o X => American Express
  numeroCdc: '1234567890123456', // numero carta
  numeroCdcLast5Digits: '12345', // ultimi 5 numeri della carta
  numeroCdcLast4Digits: '3456', // ultimi 4 numeri della carta
  numeroCdcFirst4Digits: '1234', // primi 4 numeri della carta
  numeroCdcFirstAndLast4Digits: '1234********3456', // primi 4 e ultimi 4 numeri della carta
  ccvCarta: '111', // codice di sicurezza
  scadenzaCdc: '12/22', // scadenza carta
  nomeCdc: 'Industries spa', // nome sulla carta, cardHolder name
  ragioneSocLunga: 'Aci bluteam', // ragione sociale della società
  partitaIvaSocieta: '123456789', // partita iva della società
  partitaIvaHotel: '123456789', // partita iva dell'hotel
  indirizzo: 'Via roma 1', // indirizzo della società
  localita: 'Roma', // località della società
  cap: '00100', // cap della
  provincia: 'RM', // provincia della società
  nazione: 'IT' // nazione della società
}

export const getValueFromJsonExample = (jsonKey) => {
  const keys = jsonKey.split('.')
  let value = JsonExample
  keys.forEach(key => { value = value?.[key] })
  return value?.toString() || ''
}

export const getLabel = (jsonKey) => {
  const labelMap = {
    codiceHotel: 'Codice Hotel',
    ragioneHotel: 'Ragione Hotel',
    paxVou: 'Pax Voucher',
    dataInVouEng: 'Data Check-in',
    dataOutVouEng: 'Data Check-out',
    riferimentoVou: 'Riferimento Voucher',
    flagCamera: 'Flag Camera',
    flagCityTax: 'Flag City Tax',
    flagColazione: 'Flag Colazione',
    flagCena: 'Flag Cena',
    flagFullCredit: 'Flag Full Credit',
    desOthers: 'Descrizione Altri Servizi',
    tipoCdc: 'Tipo Carta di Credito',
    numeroCdc: 'Numero Carta di Credito',
    numeroCdcLast5Digits: 'Ultimi 5 Numeri Carta di Credito',
    numeroCdcLast4Digits: 'Ultimi 4 Numeri Carta di Credito',
    numeroCdcFirst4Digits: 'Primi 4 Numeri Carta di Credito',
    numeroCdcFirstAndLast4Digits: 'Primi 4 e Ultimi 4 Numeri Carta di Credito',
    ccvCarta: 'CCV Carta',
    scadenzaCdc: 'Scadenza Carta di Credito',
    nomeCdc: 'Nome sulla Carta di Credito',
    ragioneSocLunga: 'Ragione Sociale',
    partitaIvaSocieta: 'Partita IVA',
    partitaIvaHotel: 'Partita IVA Hotel',
    indirizzo: 'Indirizzo',
    localita: 'Località',
    cap: 'CAP',
    provincia: 'Provincia',
    nazione: 'Nazione',
    phone: 'Telefono',
    email: 'Email'
  }
  return labelMap[jsonKey] || jsonKey
}

const fieldCategories = {
  'Informazioni Hotel': [
    'ragioneHotel',
    'partitaIvaHotel'
  ],
  Ospite: [
    'paxVou',
    'riferimentoVou'
  ],
  Date: [
    'dataInVouEng',
    'dataOutVouEng'
  ],
  Servizi: [
    'flagCamera',
    'flagCityTax',
    'flagColazione',
    'flagCena',
    'flagFullCredit',
    'desOthers'
  ],
  Pagamento: [
    'tipoCdc',
    'numeroCdc',
    'numeroCdcFirst4Digits',
    'numeroCdcFirstAndLast4Digits',
    'numeroCdcLast4Digits',
    'numeroCdcLast5Digits',
    'ccvCarta',
    'scadenzaCdc',
    'nomeCdc'
  ],
  Società: [
    'ragioneSocLunga',
    'partitaIvaSocieta',
    'indirizzo',
    'localita',
    'cap',
    'provincia',
    'nazione',
    'phone',
    'email'
  ]
}

export const getFieldsInOrder = (fieldsObject) => {
  const fieldOrder = Object.values(fieldCategories).flat()

  // Ordinare i campi secondo l'ordine definito, quindi aggiungere eventuali nuovi campi in fondo
  const sortedEntries = Object.entries(fieldsObject).sort(([keyA], [keyB]) => {
    const indexA = fieldOrder.indexOf(keyA)
    const indexB = fieldOrder.indexOf(keyB)

    const orderA = indexA === -1 ? fieldOrder.length : indexA
    const orderB = indexB === -1 ? fieldOrder.length : indexB

    return orderA - orderB
  })

  return Object.fromEntries(sortedEntries)
}

export const getGroupedFields = (fieldsObject) => {
  const grouped = {}

  // Inizializza le categorie
  Object.keys(fieldCategories).forEach(category => {
    grouped[category] = {}
  })
  // Raggruppa i campi
  Object.entries(fieldsObject).forEach(([key, value]) => {
    let found = false
    for (const [category, fields] of Object.entries(fieldCategories)) {
      if (fields.includes(key)) {
        grouped[category][key] = value
        found = true
        break
      }
    }
    if (!found) {
      // Assegna i campi non categorizzati alla categoria di fallback 'Società'
      grouped['Società'] = grouped['Società'] || {}
      grouped['Società'][key] = value
    }
  })

  // Filtra le categorie vuote
  return Object.fromEntries(
    Object.entries(grouped).filter(([, fields]) => Object.keys(fields).length > 0)
  )
}
